<template>
  <v-data-table
    :loading="is.loading"
    :headers="table.cols"
    :items="table.rows"
    :server-items-length="totalUsers"
    :options.sync="paginate"
    :footer-props="{ itemsPerPageOptions: [20] }"
    :fixed-header="true"
    :height="height"
    class="rounded-lg"
  >
    <template v-slot:top>
      <v-toolbar class="rounded-lg" flat color="white" height="90">
        <v-container fluid class="rounded-lg">
          <v-row>
            <v-col
              :cols="filterByMerchant ? 5 : 10"
              :sm="filterByMerchant ? 4 : 8"
              :md="filterByMerchant ? 3 : 6"
              :lg="filterByMerchant ? 3 : 6"
            >
              <v-text-field
                v-model="search"
                @keyup.enter.native="debounceSearch"
                prepend-inner-icon="mdi-magnify"
                placeholder="Search..."
                clearable
                @click:clear="search = ''"
              />
            </v-col>
            <v-col cols="2" sm="4" md="6" lg="6" class="text-right">
              <user-create-update-dialog
                :disabled="is.loading"
                v-model="editedItem"
                :merchant="merchant"
                @created="get"
                @updated="get"
                @closed="
                  editedIndex = -1
                  editedItem = {}
                "
              />
            </v-col>
          </v-row>
        </v-container>
      </v-toolbar>
    </template>
    <template v-slot:item.groups="{ item }">
      <v-chip v-if="item.is_admin" color="warning " class="mx-1">
        Admin
      </v-chip>
      <v-chip
        v-else
        outlined
        class="mx-1"
        v-for="(g, i) in item.groups"
        :key="i"
      >
        {{ g.name }}
      </v-chip>
    </template>
    <template v-slot:item.is_admin="{ item }">
      <v-chip :color="item.is_admin ? 'success' : 'default'">
        {{ item.is_admin ? "Oui" : "Non" }}
      </v-chip>
    </template>
    <template v-slot:item.action="{ item, index }">
      <!-- <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            :disabled="!item.merchant || item.is_admin"
            rounded
            fab
            color="grey white--text"
            class="mr-3"
            x-small
            v-on="on"
            @click="preview(item)"
            target="_blank"
          >
            <v-icon small>
              mdi-eye
            </v-icon>
          </v-btn>
        </template>
        <span>Prévisualiser</span>
      </v-tooltip> -->
      <template v-if="!item.temporaryPassword">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="$store.getters.isUserAdmin"
              rounded
              fab
              :disabled="
                buttonsDisabled || item.username == $store.state.user.username
              "
              outlined
              class="mr-3"
              x-small
              v-on="on"
              @click="editItem(item)"
            >
              <v-icon small>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editer</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              :loading="invitationLoading"
              :disabled="
                buttonsDisabled || item.has_accepted_invitation != false
              "
              outlined
              rounded
              class="mr-3"
              fab
              x-small
              v-on="on"
              @click="resendInvite(item)"
            >
              <v-icon small>
                mdi-email-sync
              </v-icon>
            </v-btn>
          </template>
          <span>Réenvoyer invitation</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              :loading="resetPasswordLoading"
              :disabled="item.is_admin || buttonsDisabled"
              outlined
              rounded
              class="mr-3"
              fab
              x-small
              v-on="on"
              @click="resetUserPassword(item, index)"
            >
              <v-icon small>
                mdi-key
              </v-icon>
            </v-btn>
          </template>
          <span>Réinitialiser le mot de passe</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="$store.getters.isUserAdmin"
              :disabled="
                buttonsDisabled || item.username == $store.state.user.username
              "
              outlined
              rounded
              fab
              x-small
              v-on="on"
              @click="deleteItem(item)"
            >
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Supprimer</span>
        </v-tooltip>
      </template>
      <template v-else>
        <v-chip>
          {{
            item.temporaryPasswordHidden
              ? "*".repeat(item.temporaryPassword.length)
              : item.temporaryPassword
          }}

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                class="ml-2"
                @click="
                  item.temporaryPasswordHidden = !item.temporaryPasswordHidden
                "
                v-on="on"
              >
                {{ item.temporaryPasswordHidden ? "mdi-eye" : "mdi-eye-off" }}
              </v-icon>
            </template>
            <span>Cacher</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                class="ml-1"
                @click="copyToClipboard(item.email, item.temporaryPassword)"
                v-on="on"
              >
                mdi-clipboard-text-outline
              </v-icon>
            </template>
            <span>Copier dans le presse-papier</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                class="ml-1"
                @click="item.temporaryPassword = null"
                v-on="on"
              >
                mdi-close
              </v-icon>
            </template>
            <span>Cacher les infos</span>
          </v-tooltip>
        </v-chip>
      </template>
    </template>
  </v-data-table>
</template>

<script>
import CompanyService from "@/services/hmd/CompanyService"
import UserCreateUpdateDialog from "@/components/hmd/Users/UserCreateUpdateDialog"
import { debounce } from "lodash"
import { UtilService } from "@/services"
export default {
  components: {
    UserCreateUpdateDialog
  },
  props: {
    merchant: {
      type: String,
      default: ""
    },
    height: {
      type: Number,
      default: 300
    },
    filterByMerchant: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    search: "",
    paginate: {},
    table: {
      rows: [],
      cols: [
        { text: "First name", value: "first_name", sort: false },
        { text: "Last name", value: "last_name", sort: false },
        { text: "Email", value: "email", sort: false },
        { text: "Brand/Status", value: "groups", sort: false },
        { text: "Actions", value: "action", sort: false }
      ]
    },
    totalUsers: 0,
    editedIndex: -1,
    editedItem: {},
    is: {
      loading: false
    },
    page: 1,
    invitationLoading: false,
    resetPasswordLoading: false,
    buttonsDisabled: false
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item"
    },
    isActionsDisabled() {
      return this.is.loading
    }
  },

  watch: {
    search(vn, vo) {
      if (this.paginate.page > 1) this.paginate.page = 1
      if (this.search == "") {
        this.debounceSearch()
      }
    },

    paginate: {
      deep: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          if (oldValue.page) {
            this.get()
          }
        })
      }
    },
    dialog(val) {
      val || this.close()
    }
    // page(newValue, oldValue) {
    //   if (newValue !== oldValue) {
    //     this.get()
    //   }
    // }
  },

  mounted() {
    this.$nextTick(() => {
      this.get()
    })
    // this.editedItem.merchant = this.merchant
  },

  methods: {
    debounceSearch: debounce(function() {
      this.get()
    }, 1000),

    preview(user) {
      this.$store.commit("setPreview", user)
      this.$router.push("Index").catch(() => {})
    },
    handleFilterChange() {
      const self = this
      this.$nextTick(() => {
        self.get()
      })
    },
    get() {
      this.is.loading = true

      const paginate = {
        page: this.paginate.page,
        page_size: this.paginate.itemsPerPage
      }

      return CompanyService.User.list(
        this,
        paginate,
        this.merchant,
        this.search
      )
        .then(r => {
          this.table.rows = r.results.sort((a, b) => b.pk - a.pk)
          this.totalUsers = r.count
        })
        .finally(() => (this.is.loading = false))
    },

    editItem(item) {
      this.editedIndex = this.table.rows.indexOf(item)
      this.editedItem = Object.assign({}, item)
    },
    resendInvite(item) {
      this.invitationLoading = true
      this.buttonsDisabled = true
      UtilService.resendInvitation(item.email)
        .then(r => {
          this.$store.commit("success", "Invitation sent")
          this.dialog = false
        })
        .finally(() => {
          this.invitationLoading = false
          this.buttonsDisabled = false
        })
    },
    resetUserPassword(item, index) {
      if (confirm("Are you sure you want to reset this user's password?")) {
        this.invitationLoading = true
        this.buttonsDisabled = true
        UtilService.resetUserPassword(item.pk)
          .then(r => {
            this.$set(this.table.rows[index], "temporaryPassword", r.password)
            this.$set(this.table.rows[index], "temporaryPasswordHidden", true)
            this.$store.commit("success", `User password reset`)
            this.dialog = false
          })
          .catch(error => {
            let err = error.response.data.error
            this.$store.commit("error", { msg: err, color: "error" })
            this.dialog = false
          })
          .finally(() => {
            this.invitationLoading = false
            this.buttonsDisabled = false
          })
      }
    },
    copyToClipboard(email, value) {
      navigator.clipboard.writeText(value).then(r => {
        this.$store.commit(
          "success",
          `Mot de passe pour ${email} copié dans le presse-papier`
        )
        this.dialog = false
      })
    },
    deleteItem(item) {
      const index = this.table.rows.indexOf(item)
      if (confirm("Are you sure you want to delete this item?")) {
        CompanyService.User.delete(this, item.pk).then(() => {
          this.table.rows.splice(index, 1)
        })
      }
    }
  }
}
</script>

<style scoped></style>
